import { has } from 'lodash';

export class ParentShareReviewProcessToggleError {
  
  static UNRELEASED_OBSERVATIONS_EXIST_KEY = 'validation_UnreleasedObservationsExist';
  
  get unreleasedObservationsExist() {
    return has(this._error.modelState, ParentShareReviewProcessToggleError.UNRELEASED_OBSERVATIONS_EXIST_KEY);
  }
  
  _error;
  
  /**
   * @param {AppError} error
   */
  constructor(error) {
    this._error = error;
  }
  
}
